import { BehaviorSubject, Observable } from "rxjs";

import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@env/environment";
import { CheckNumberPlateEvalLeadRequest, CheckNumberPlateEvalLeadResponse, EvalLeadRequest, SaveEvalLeadResponse } from "./plugin-raiox-lead.model";
import { DefaultStatus } from "@app-model/login";
import { DefaultMessage } from "@app/views/private/admin/services/user-manager.service";
import { SafeUrl } from "@angular/platform-browser";
import { EvalDealerPersonalizationConfig } from "../eval-dealer-personalization-model";

@Injectable({
  providedIn: "root",
})
export class PluginRaioXService {
  constructor(private http: HttpClient) { }

  private primaryColor = new BehaviorSubject<string>('');
  primaryColor$ = this.primaryColor.asObservable();

  setPrimaryColor(color: string){
    this.primaryColor.next(color);
  }

  saveInitialEvalLead(lead: EvalLeadRequest): Observable<SaveEvalLeadResponse> {
    return this.http.post(
      `${environment.api}/open/saveInitialEvalLead`,
      lead
    ) as Observable<SaveEvalLeadResponse>;
  }

  saveEvalLead(lead: EvalLeadRequest): Observable<SaveEvalLeadResponse> {
    return this.http.post(
      `${environment.api}/open/saveEvalLead`,
      lead
    ) as Observable<SaveEvalLeadResponse>;
  }

  checkNumberPlate(request: CheckNumberPlateEvalLeadRequest): Observable<CheckNumberPlateEvalLeadResponse> {
    return this.http.post(
      `${environment.api}/open/checkNumberPlateEvalLead`,
      request
    ) as Observable<CheckNumberPlateEvalLeadResponse>;
  }

  submitLeadSchedule(id: string, scheduledDate: Date, scheduledEvalDealerId: string) {
    const request = { id, scheduledDate, evalDealerId: scheduledEvalDealerId };
    return this.http.post(
      `${environment.api}/open/scheduleEvalLeadVisit`,
      request
    ) as Observable<DefaultMessage>;
  }

  saveAudioOrMessage(id: string, blob: Blob, duration: number, audioFormat: string, message: string): Observable<DefaultMessage> {
    const formData = new FormData();
    formData.append('file', blob === undefined ? null : blob);
    formData.append('duration', duration ? duration.toString() : null);
    formData.append('message', message);
    formData.append('evalLeadId', id);
    formData.append('format', audioFormat);

    return this.http.post<DefaultMessage>(`${environment.api}/open/saveVehicleDescription`, formData);
  }
}
export class AudioHelper {
  url: string | SafeUrl;
  duration: number;
}